import 'regenerator-runtime';

import React from 'react';
import { render } from 'react-dom';
import { Router, Route, Switch } from 'react-router-dom';
import {createBrowserHistory, createHashHistory} from 'history';
import { TrackJS } from 'trackjs';
import isElectron from 'is-electron';

import App from './containers/App';
import Framework from '@beardeddevops/react.framework';
import {defaultState} from 'constants/State';

const history = isElectron() ? createHashHistory() : createBrowserHistory();

if (process.env.production) {
	TrackJS.install({
		token: "197cc3fbd1be4e3cb724189bb24d4483",
		application: "pos_admin",
		version: "1"
		// for more configuration options, see https://docs.trackjs.com
	});
}

render(
	<Framework.Components.RootState defaultState={defaultState}>
		<Router history={history}>
			<Switch>
				<Route path="/" component={App} />
			</Switch>
		</Router>
	</Framework.Components.RootState>,
	document.getElementById('app-container')
);
